var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIndustry = function SvgIndustry(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M16.344 16.6H3.658a.663.663 0 0 1-.63-.7L3 4.688A.675.675 0 0 1 3.658 4H6.72a.675.675 0 0 1 .656.689v5.641l3.804-2.55a.63.63 0 0 1 .35-.108.676.676 0 0 1 .658.69v1.96l3.831-2.542a.6.6 0 0 1 .345-.108.666.666 0 0 1 .635.696v7.531a.68.68 0 0 1-.655.7m-3.907-4.2v1.25h1.191V12.4zm-2.633 0v1.25h1.191V12.4zm-2.646 0v1.25h1.19V12.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIndustry);
export default ForwardRef;